const { vm } = require("./initial-state");
const { addPartToVM } = require("./utils/add-part");
const { copyBlocks } = require("./utils/apply-glitch");
const { updateSpriteList } = require("./utils/arcade-vm-hooks");
const uuid = require("./utils/uuid.js");
const log = require("../shared_utils/log.js");

module.exports = function store(state, emitter) {
  // add a listener so that if the user presses shift-r at the same time, we emit the refresh-glitches event
  document.addEventListener("keydown", (e) => {
    if ((e.key === "r" || e.key == "R") && e.shiftKey) {
      emitter.emit("glitches");
    }
  });

  function cleanUpExtraBlocks() {
    state.addedParts.forEach((part) => {
      const target = state.vm.runtime.targets.find(
        (t) => t.sprite.name === part.spriteName
      ).sprite.clones[0];
      const scripts = target.blocks.getScripts();
      console.log("scripts", scripts);
      let allowedBlockIds = [];
      state.glitchApplications.forEach((glitchApplication) => {
        const glitchId = glitchApplication.glitchId;
        const glitch = state.availableGlitches.find((g) => g.id === glitchId);
        if (glitchApplication.targetId === target.id) {
          allowedBlockIds = allowedBlockIds.concat(
            glitchApplication.targetBlockIds
          );
        } else {
          allowedBlockIds = allowedBlockIds.concat(
            glitchApplication.otherSpritesBlockIds
          );
        }
      });

      const partCode = state.availableParts.find(
        (p) => p.id === part.partId
      ).code;
      const partCodeTarget = partCode.targets[1];
      const partCodeBlocks = partCodeTarget.blocks;
      const blockIds = Object.keys(partCodeBlocks);
      allowedBlockIds = allowedBlockIds.concat(blockIds);
      scripts.forEach((blockId) => {
        if (allowedBlockIds.indexOf(blockId) === -1) {
          const block = target.blocks.getBlock(blockId);
          target.blocks.deleteBlock(blockId);
        }
      });
    });
  }

  function refreshGlitchesInCurrentScene() {
    const changedGlitches = [];
    state.glitchApplications.forEach((glitchApplication) => {
      const glitchId = glitchApplication.glitchId;
      const glitch = state.availableGlitches.find((g) => g.id === glitchId);
      if (glitch.checkSum !== glitchApplication.checkSum) {
        changedGlitches.push(glitchApplication);
      }
    });
    if (
      changedGlitches.find(
        (glitchApplication) => glitchApplication.glitchId === "builtin_physics"
      )
    ) {
      state.vm.runtime.targets[0].blocks.deleteAllBlocks();
    }
    changedGlitches.forEach((glitchApplication) => {
      const glitchId = glitchApplication.glitchId;
      const targetId = glitchApplication.targetId;
      emitter.emit("remove-glitch", glitchApplication.id);
    });
    changedGlitches.forEach((glitchApplication) => {
      const glitchId = glitchApplication.glitchId;
      const targetId = glitchApplication.targetId;
      emitter.emit("apply-glitch", glitchId, targetId);
    });
  }

  emitter.on("clean-up-extra-blocks", () => {
    cleanUpExtraBlocks();
    emitter.emit("render");
  });

  emitter.on("refresh-glitches", (forceRefresh) => {
    console.log("refresh-glitches", forceRefresh);
    refreshGlitchesInCurrentScene(forceRefresh);
    emitter.emit("render");
  });

  emitter.on("refresh-project", () => {
    state.isGamePlaying = false;
    state.wasGamePlaying = false;
    const delay = 3000;
    emitter.emit("pause");
    const scenes = state.project.scenes.length;
    emitter.emit("refresh-glitches");
    let loads = 0;

    function tryToLoadScene(sceneId) {
      if (!state.isSceneLoading) {
        emitter.emit("load-scene", sceneId);
        loads++;
        return true;
      } else {
        return false;
      }
    }
    let sceneToLoad = 1;
    const interval = setInterval(() => {
      if (sceneToLoad >= state.project.scenes.length) {
        emitter.emit("load-scene", 0);
        setTimeout(() => emitter.emit("export-project"), delay);
        clearInterval(interval);
      } else {
        let loaded = tryToLoadScene(sceneToLoad);
        if (loaded) {
          sceneToLoad++;
          setTimeout(() => emitter.emit("refresh-glitches"), delay);
        }
      }
    }, delay * 2);
  });

  function isVariableUsedInTarget(variable, target) {
    const varId = variable.id;
    const varName = variable.name;
    const blocks = target.sprite.blocks._blocks;
    for (const blockId in blocks) {
      let varOrListField = null;
      if (blocks[blockId].fields.VARIABLE) {
        varOrListField = blocks[blockId].fields.VARIABLE;
      } else if (blocks[blockId].fields.LIST) {
        varOrListField = blocks[blockId].fields.LIST;
      }
      if (varOrListField) {
        const currFieldId = varOrListField.id;
        if (varId === currFieldId) {
          return true;
        }
      }
      if (
        blocks[blockId].fields.PROPERTY &&
        blocks[blockId].fields.PROPERTY.contains(varName)
      ) {
        return true;
      }
    }
    return false;
  }

  function isGlobalVarUsed(varId, targets) {
    for (let i = 0; i < targets.length; i++) {
      if (isVariableUsedInTarget(varId, targets[i])) {
        return true;
      }
    }
    return false;
  }
};
